import React, { memo } from 'react';
import classnames from 'classnames';
import { IconBackgroundColors, IconColors, IconSizes, IconVariants } from '../../constants';
import './Icon.scss';
const Icon = ({ color = IconColors.Primary, variant = IconVariants.Plain, size = IconSizes.Medium, backgroundColor = IconBackgroundColors.Primary, children = null, }) => {
    const rootClassNames = classnames({
        'ml-icon': true,
        [`ml-icon--size-${size}`]: true,
        [`ml-icon--variant-${variant}`]: true,
        [`ml-icon--color-${color}`]: true,
        [`ml-icon--background-color-${backgroundColor}`]: true,
    });
    return (<div className={rootClassNames}>
      <div className="ml-icon__content">
        {children}
      </div>
    </div>);
};
export default memo(Icon);
